export const blueColor = 'rgba(0, 168, 232, 0.79)';
export const redGradient = 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)';
export const blueGradient = 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)';
export const whiteLavender = '#E6E6FA';
export const blackGradient = 'linear-gradient(to bottom, #3a404d, #181c26)';
